import { DialogRef } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import {
  resolvePlatform,
  resolveStoreUrl,
} from '../../../core/platform/store-url.util';

@Component({
  selector: 'app-access-modal',
  templateUrl: './access-modal.component.html',
  styleUrl: './access-modal.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class AccessModalComponent {
  private readonly dialogRef = inject(DialogRef);
  private readonly router = inject(Router);

  readonly destinations = environment;
  // La decisión de plataforma vive en `store-url.util`, no repetida acá: la
  // página de descarga del QR necesita exactamente la misma y dos copias
  // divergen (ABC-399).
  readonly isDesktop = resolvePlatform(navigator.userAgent) === 'desktop';
  readonly hasAppDestination = this.isDesktop
    ? Boolean(environment.appStoreUrl || environment.playStoreUrl)
    : Boolean(
        resolveStoreUrl(navigator.userAgent, {
          appStoreUrl: environment.appStoreUrl,
          playStoreUrl: environment.playStoreUrl,
        }),
      );

  close(): void {
    this.dialogRef.close();
  }

  openClientAccess(): void {
    this.dialogRef.close();
    void this.router.navigate(['/auth/sign-in']);
  }

  openExternal(url: string): void {
    if (!url) {
      return;
    }
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  openStore(store?: 'app-store' | 'play-store'): void {
    const stores = {
      appStoreUrl: environment.appStoreUrl,
      playStoreUrl: environment.playStoreUrl,
    };
    const url =
      store === 'app-store'
        ? stores.appStoreUrl
        : store === 'play-store'
          ? stores.playStoreUrl
          : resolveStoreUrl(navigator.userAgent, stores);
    this.openExternal(url);
  }
}
